import {make} from "vuex-pathify"
import Auxiliar from "@/API/Auxiliar"

const state = {
    isLoading: false,
    currencies: [],
    form: {
        name_locale: {}
    },
    page: [],
}

const mutations = make.mutations(state)

const actions = {
    loading({commit}) {
        commit('SET_IS_LOADING', true)
    },
    loaded({commit}) {
        commit('SET_IS_LOADING', false)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
